import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

// Components
import { DialogConfig } from '../../../shared/configs/dialog.config';
import { PaginationConfig } from '../../../shared/configs/paginator.config';
import { SupplierSkuApiService } from '../../../shared/services/api/supplier/supplier-sku-api.service';
import { ISupplierSku } from '../../interfaces/supplier-sku.interface';
import { SupplierSkuFormComponent } from '../supplier-sku-form/supplier-sku-form.component';

// Configs

// Interfaces

// Services

@Component({
  selector: 'lum-supplier-sku',
  templateUrl: './supplier-sku.component.html',
  styleUrls: ['./supplier-sku.component.scss'],
})
export class SupplierSkuComponent implements OnInit, OnDestroy {
  @Input()
  rfq :any; // Todo: Define RFQ interface

  loading :boolean = false;
  paginationConfig = PaginationConfig;
  pagination :any = {};
  supplierSkus :ISupplierSku[] = []; // Todo: Define SupplierSku interface
  params :{ [param :string] :string | string[] } = {
    relations: 'supplier,product',
  };

  private onDestroy$ = new Subject<void>();

  constructor(
    private cd :ChangeDetectorRef,
    private dialog :MatDialog,
    private supplierSkuApiService :SupplierSkuApiService,
  ) {}

  ngOnInit() :void {
    this.getSupplierSkus();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onPaginationEvent(pagination :PageEvent) :void {
    this.params = {
      ...this.params,
      limit: pagination.pageSize.toString(),
      page: (pagination.pageIndex + 1).toString(),
    };
    this.getSupplierSkus();
  }

  onOpenSupplierSkuForm() :void {
    this.dialog
      .open(SupplierSkuFormComponent, {
        data: {
          rfq: this.rfq,
        },
        width: DialogConfig.sizes.medium,
        disableClose: true,
      })
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => this.cd.detectChanges()),
      )
      .subscribe((response) => {
        if (response) {
          this.getSupplierSkus();
        }
      });
  }

  onRefreshSupplierSkuEvent(event :boolean) :void {
    if (event) {
      this.getSupplierSkus();
    }
  }

  private getSupplierSkus() :void {
    this.loading = true;
    this.supplierSkuApiService
      .get({ productIds: this.rfq.id, ...this.params })
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => this.cd.detectChanges()),
      )
      .subscribe({
        next: (response) => {
          const { data, meta } = response;
          this.supplierSkus = data;
          this.pagination = meta;
        },
        complete: () => {
          this.loading = false;
        },
      });
  }
}
